export class ImageModel { 
    id : number;
    altText : string;
    isPrimary  : boolean;
    isVedio : boolean;
    image : File | string;
    imageUrl : string;
    isActive : boolean;
    ImageAsBase64 : string;
    isLoading : boolean;
    isLoaded : boolean;
    uploadLabel : string;
    productId : number;
    constructor(){
        this.id = 0;
        this.altText = '';
        this.isActive = true;
        this.isPrimary = false;
        this.isVedio = false;
        this.ImageAsBase64 = '';
        this.imageUrl ='';
        this.isLoading = false;
        this.isLoaded = false;
        this.uploadLabel = 'Upload';
    }
}